export interface IPricePayload {
  readonly id: number
  readonly value: number
}

export interface ICurrencyData {
  readonly id: number
  readonly slug: string
  readonly name: string
  readonly coefficient?: number
}

export interface ICurrency extends ICurrencyData {
  readonly coefficient: number

  validate(): boolean
}

export const CURRENCY_NAME_MAX_LENGTH = 20;
export const CURRENCY_SLUG_MAX_LENGTH = 5;
